/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontPublicRpc
 */
import * as References from './MarketplaceStorefrontPublicRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontPublicRpc#getSearchFilterConfig
 */
export const GET_SEARCH_FILTER_CONFIG_QUERY_FIELD_NAME = 'com_hubspot_marketplace_storefront_service_rpc_MarketplaceStorefrontPublicRpc_getSearchFilterConfig';
export const GET_SEARCH_FILTER_CONFIG_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SEARCH_FILTER_CONFIG_QUERY_FIELD_NAME,
  args: ['language'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getSearchFilterConfigRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontPublicRpc#getPaginatedSearchFilterOptions
 */
export const GET_PAGINATED_SEARCH_FILTER_OPTIONS_QUERY_FIELD_NAME = 'com_hubspot_marketplace_storefront_service_rpc_MarketplaceStorefrontPublicRpc_getPaginatedSearchFilterOptions';
export const GET_PAGINATED_SEARCH_FILTER_OPTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PAGINATED_SEARCH_FILTER_OPTIONS_QUERY_FIELD_NAME,
  args: ['field', 'page', 'search', 'language'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getPaginatedSearchFilterOptionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontPublicRpc#getBatchSearchFilterOptions
 */
export const GET_BATCH_SEARCH_FILTER_OPTIONS_QUERY_FIELD_NAME = 'com_hubspot_marketplace_storefront_service_rpc_MarketplaceStorefrontPublicRpc_getBatchSearchFilterOptions';
export const GET_BATCH_SEARCH_FILTER_OPTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_BATCH_SEARCH_FILTER_OPTIONS_QUERY_FIELD_NAME,
  args: ['filters', 'includeHelpText', 'language'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getBatchSearchFilterOptionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});